// Global
import React from 'react';
//Local
import { ProductResponse } from 'lib/services/models/content-response';
import useDictionary from 'lib/hooks/useDictionary';
import styles from './PrepInstructions.module.scss';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';

export interface PrepInstructionsProps {
  product?: ProductResponse;
}
export function ProductPrepInstructions(props: PrepInstructionsProps) {
  const product = props.product;
  const { getDictionaryValue } = useDictionary();

  const headerText =
    getDictionaryValue('Components.Product.PrepInstructions.Header') || 'Prep instructions';

  const emptyStateText =
    getDictionaryValue('Components.Product.PrepInstructions.EmptyStateText') ||
    'Prep instructions are not available for this product';

  const hasInstructions = product?.PreparationInstructions?.length;

  return (
    <div className={styles.prepInstructionsWrapper}>
      <h2 className={styles.prepInstructionsHeading}>{headerText}</h2>
      {hasInstructions ? (
        product.PreparationInstructions?.map((instr, idx) => (
          <EnhancedRichText
            key={idx}
            className={styles.prepInstructionsContent}
            value={instr.InstructionText}
          />
        ))
      ) : (
        <p className={styles.prepInstructionsContent}>{emptyStateText}</p>
      )}
    </div>
  );
}
